import React, { memo } from "react";
import AmsaInput from "./AmsaInput";
import AmsaStaticSelect from "./AmsaStaticSelect";
import AmsaDateInput from "./AmsaDateInput";
import AmsaEditor from "./AmsaEditor";
import FasciaChart from "../../components/FasciaChart";
import SymptomSelect from "../visits/SymptomSelect";
import { Visit } from "../../interfaces/Visit";
import DiseaseSelect from "../visits/DiseaseSelect";
import MedicineSelect from "../visits/MedicineSelect";
import MedicineInstructions from "../visits/MedicineInstructions";
import VisitFiles from "../visits/VisitFiles";
import GTPAL from "./GTPAL";
import LMP from "./LMP";

const componentRegistry: { [key: string]: React.FC<any> } = {
  AmsaInput,
  AmsaStaticSelect,
  AmsaDateInput,
  AmsaEditor,
  FasciaChart,
  SymptomSelect,
  DiseaseSelect,
  MedicineSelect,
  MedicineInstructions,
  VisitFiles,
  GTPAL,
  LMP,
};

interface DynamicComponentRendererProps {
  gridItem: any;
  setValue: any;
  shouldFocus?: boolean;
  visit?: Visit;
  isPreview?: boolean;
  onEvent?: (eventName: string, payload: any) => void;
}

const DynamicComponent: React.FC<DynamicComponentRendererProps> = ({
  gridItem,
  setValue,
  shouldFocus,
  visit,
  isPreview = false,
  onEvent,
}) => {
  // Check if the component with the given name exists in the registry
  const Component = componentRegistry[gridItem.component];

  if (!Component) {
    return <div>Component {gridItem.component} not found.</div>;
  }

  return (
    <Component
      isPreview={isPreview}
      visit={visit}
      data={gridItem.data}
      {...gridItem.data.props}
      setValue={setValue}
      shouldFocus={shouldFocus}
      onMedicineCreate={(payload: string) =>
        onEvent && onEvent("create-medicine", payload)
      }
    />
  );
};

export default memo(DynamicComponent);
